import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { BreadCrumb } from 'src/app/models/common/bread-crumb';
import { PageHeader } from 'src/app/models/common/page-header';
import { BaseSearchComponent } from 'src/app/system-common/base-search/base-search.component';
import { HeaderService } from 'src/app/system-common/services/header.service';

import { SettingService } from 'src/app/system-common/services/setting.service';
import { SearchResponseIO } from 'src/app/models/search-responseIO';
import { FinanceService } from '../services/finance.service';

@Component({
  selector: '',
  template: '',
})
export class PaymentStatementSearchHandler extends BaseSearchComponent<FinanceService> implements OnInit {
  public searchName: string;
  isAdvanceSearchDisplayed: boolean;
  isStatementDownloadFail: boolean;
  message: String;
  constructor(
    public service: FinanceService,
    public headerService: HeaderService,
    public router: Router,
    public settingService: SettingService
  ) {
    super(service, router, headerService);
    // this.addLink = '/search-payment-statement';
    //this.service.isAuditButtonClicked = false;
    // this.isSearchFilteredByCriteria = true;
  }

  ngOnInit() {
    super.ngOnInit();

    this.searchName = 'SearchPaymentStatement';

    //this.service.forAuditSearchList = false;
    this.settingService.removeSessionStorage('AuditChanges');
    this.isAdvanceSearchDisplayed = true;
    this.isStatementDownloadFail = false;
  }

  protected getBreadCrumbList(): BreadCrumb[] {
    return [
      {
        id: 'Home',
        link: '/home',
      },
      {
        id: 'Search',
      },
    ];
  }

  protected getMoreOptionList(): any[] {
    return [
      {
        id: 'Download',
        link: '/search-payment-statement/:id',
      },
    ];
  }

  protected getPageHeader(): PageHeader {
    let header = new PageHeader();
    // header.title = 'Payment Statement';
    header.title = this.settingService.getLabelValue('paymentStatement');
    return header;
  }

  Download_click(optionDetails: { button_id; link; ref_id }) {
    let link: string;
    link = optionDetails.link.toString().replace(':id', optionDetails.ref_id);
    //this.router.navigate([link]);
    this.getPaymentStatement(optionDetails.ref_id);
  }

  Audit_click(buttonClicked: { button_id: string; link: string; ref_id }) {
    this.service.id = buttonClicked.ref_id;
    setTimeout(() => {
      //this.service.isAuditButtonClicked = true;
    }, 10);
  }

  getPaymentStatement(dmsreferenceSeq) {
    this.service.downloadPaymentStatement(dmsreferenceSeq).subscribe((successResponse) => {
      let respData = JSON.parse(JSON.stringify(successResponse));
      if (respData.success) {
        this.isStatementDownloadFail = false;
        this.service.responseIO = respData;
        this.downloadOrOpenContent(respData.data.fileContents, 'pdf', respData.data.filename);
      } else {
        this.isStatementDownloadFail = true;
        this.message = respData.message;
        this.openModal('downloadPopup');
      }
    });
  }
}
